import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button } from '@storable/canaveral-components';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import styles from './OverlayButton.scss';

const propTypes = {
  className: PropTypes.string,
  overlayText: PropTypes.node,
};

const defaultProps = {
  className: undefined,
  overlayText: undefined,
};

const OverlayButton = ({ overlayText, className, ...props }) => {
  if (!overlayText) {
    return (
      <Button {...props} />
    );
  }

  const overlay = (
    <Popover id="overlay-button-popover">
      {overlayText}
    </Popover>
  );

  return (
    <OverlayTrigger
      overlay={overlay}
      placement="bottom"
      trigger={['hover', 'focus']}
    >
      <div className={styles.wrapper}>
        <Button {...props} className={cx(styles.button, className)} />
      </div>
    </OverlayTrigger>
  );
};

OverlayButton.propTypes = propTypes;
OverlayButton.defaultProps = defaultProps;

export default OverlayButton;
